module.exports = __webpack_public_path__ + "070abc3bc523756b0cd5d2fbd5f567d0.png";